import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './_ActionModals.scss';
import Button from 'react-bootstrap/Button';
import CommonConfiramation from '../../../../common/base/CommonConfiramation/CommonConfiramation';

function ActionModals({show, onClose, onSubmit, type, requestData, slaTiers, isTierChange}) {
    const currentTier = requestData?.slaTier;

    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : str;

    const normalizedTiers = (slaTiers || []).map(t => ({
        id: String(t.slaTierId),
        name: capitalize(t.slaTierName),
        limits: t.limits,
        status: t.status,
        autoApprove: t.autoApprove
    }));
    const currentTierMatchId = currentTier
        ? normalizedTiers.find(t => t.name === capitalize(currentTier.name))?.id
        : undefined;

    const ModalData = {
        "approve": {
          header:"Confirm Request Approval",
          message:"Are you sure you want to Approve this Request?",
          okButtonLabel:"Approve"
        },
        "bulkApprove": {
          header:"Confirm Bulk Approval",
          message:"Are you sure you want to Approve all selected Requests?",
          okButtonLabel:"Approve All"
        },
        "deny": {
          header: isTierChange ? "Deny Tier Change Request" : "Confim Request Denial",
          provideDenialReason:true,
          message: isTierChange
            ? "Are you sure you want to deny this SLA tier change request? The requester will continue with their current tier."
            : "Are you sure you want to deny this API access request? You can approve or revoke this decision later if needed.",
          okButtonLabel:"Deny",
          sentiment:'danger'
        },
        "bulkDeny": {
          header:"Confirm Bulk Denial",
          provideDenialReason:true,
          message:"Are you sure you want to Deny all selected Requests? You can approve or revoke this decision later if needed.",
          okButtonLabel:"Deny All",
          sentiment:'danger'
        },
        "remove": {
          header:"Confim Request Removal",
          message:"Are you sure you want to Remove this Request?",
          okButtonLabel:"Remove",
          sentiment:'danger'
        },
        "editTier": {
          header:"Edit SLA Tier",
          message:"Select the new SLA tier for this request. The client will be notified of this change.",
          provideSlaTierSelect: true,
          slaTiers: normalizedTiers,
          requestStatus: requestData?.status,
          currentTierId: currentTierMatchId,
          currentTierDisplay: currentTier
            ? `${capitalize(currentTier.name)} (${currentTier.requestNumber} requests per ${currentTier.timePeriod} milliseconds)`
            : '-',
          tierLabel: 'Current SLA Tier',
          provideDenialReason: true,
          reasonRequired: false,
          reasonLabel: 'Reason for Change',
          okButtonLabel:"Continue",
          confirmationStep: {
            header: "Confirm Editing this Request",
            message: "Are you sure you want to edit this Request?",
            okButtonLabel: "Confirm"
          }
        }
      }
      const popupConfig = ModalData[type];
      return (
        <CommonConfiramation show={show} popupConfig={popupConfig} onCancel={onClose} onSubmit={(data)=>onSubmit(data)}></CommonConfiramation>
    )
}

export default ActionModals;
